import { catalogCategoryQueryToSlug, looksLikeProductSlug } from './categorySlugMap';

/** Exact legacy path → new path (no query handling). */
export const LEGACY_EXACT_REDIRECTS = {
  '/home': '/',
  '/allCategories': '/categories',
  '/contact': '/contactUs',
  '/terms': '/termsAndConditions',
  '/privacy': '/privacyPolicy',
  '/refund': '/refundPolicy',
  '/applyCoupon': '/coupon',
  '/profile': '/account',
  '/myAddresses': '/account/addresses',
  '/delivery': '/checkout',
  '/orderSummary': '/checkout/summary',
  '/makePayment': '/checkout/pay',
  '/orderStatus': '/order-status',
  '/orderDetails': '/account',
};

export function resolveLegacyRedirect(pathname, search = '') {
  if (LEGACY_EXACT_REDIRECTS[pathname]) {
    return LEGACY_EXACT_REDIRECTS[pathname];
  }

  if (pathname === '/catalog') {
    if (search) {
      const params = new URLSearchParams(search);
      const slug = catalogCategoryQueryToSlug(params);
      return `/categories/${slug}`;
    }
    return '/categories/all';
  }

  const catalogProductMatch = pathname.match(/^\/catalog\/([^/]+)$/);
  if (catalogProductMatch) {
    const segment = decodeURIComponent(catalogProductMatch[1]);
    return looksLikeProductSlug(segment) ? `/products/${segment}` : '/categories/all';
  }

  return null;
}
